import React from "react";

export const Card = ({
  children,
  title,
  subtitle,
  footerContent,
  noOverflow,
  ...rest
}) => (
  <div
    {...rest}
    className={`card ${noOverflow ? `no-overflow` : ``} ${
      rest?.className || ""
    }`}
  >
    {title && (
      <div className="card-header">
        <div>
          {/* The weight belongs in the stylesheet: as an inline style it beat
              every rule targeting card titles, so a section heading rendered
              lighter than the field labels underneath it and no CSS could
              correct it. A subtitle is secondary text, not a second heading. */}
          <h3>{title}</h3>
          {subtitle && <p className="card-subtitle">{subtitle}</p>}
        </div>
      </div>
    )}
    <div className="card-body">{children}</div>
    {footerContent && <div className="card-footer">{footerContent}</div>}
  </div>
);

export default Card;
